<template>
  <div class="error404">
    <figure class="broken-pencil">
      <BrokenPencil />
    </figure>
    <div class="message">
      <h3>An authentication error occurred.</h3>
      <button class="btn btn-lg btn-primary" to="/">Back to PTC Wizard home</button>
    </div>
  </div>
</template>

<script setup>
import BrokenPencil from "@/assets/broken-pencil.svg";
</script>
